import styled from 'styled-components';

const PerformAssignmentWholeDiv = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;
export default PerformAssignmentWholeDiv;
